import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Price extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [ 
        'inverse'
      ],
      modifiers : [],
      states : []
    }

  }
  
  render() {

    const { data, ...rest } = this.props
    const props = clearProps(this.props)
    
    return  <dl {...rest} className={resolveProps(this.props, this.config, 'Price')} >
      <dt className="mdn-Price-prefix" >
        {data.prefix}
      </dt>
      <dd className="mdn-Price-price" >
        {data.price}
        <span className="mdn-Price-price-period" >
        {data.period ? '/' + data.period : ''}
        </span>
      </dd>
      <dt className="mdn-Price-suffix" >
        {data.suffix}
      </dt>
    </dl>
  }
}

Price.propTypes = {
  data: PropTypes.object
}